import styled from "styled-components";

export const ViewPointHeight = styled.div`
  height: 100vh;
  overflow: hidden;
`;
export const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;
